<!-- Photobooth Products Section (Slide Photobooth Visidea Studio) -->
<section id="photobooth-products" class="py-20 px-8 md:px-16 xl:px-8 bg-white relative">
    <img src="/assets/visidea/orn_kiri.png"
        class="absolute top-[190px] left-[0px] md:w-12 lg:w-18 xl:w-24 hidden md:block scroll-reveal scroll-reveal-left" alt="">
    <img src="/assets/visidea/orn_kanan.png"
        class="absolute bottom-[40px] right-[0px] md:w-12 lg:w-18 xl:w-24 hidden md:block scroll-reveal scroll-reveal-right" alt="">
    <div class="max-w-7xl mx-auto">
        <div class="flex justify-between items-center mb-16 scroll-reveal scroll-reveal-up">
            <h3 class="text-lg lg:text-4xl font-normal">
                {{ 'home.products_title_prefix' | transloco }} <br class="hidden xl:block" /><span class="font-bold">{{
                    'home.products_title_brand' | transloco }}</span>
            </h3>
        </div>

        <div class="photobooth-scroll-container flex gap-6 mb-8 overflow-x-auto scrollbar-hide pt-4 pb-20 -mb-16"
            style="scroll-behavior: smooth; -webkit-overflow-scrolling: touch">
            <!-- Card 1: Vintage Photobooth -->
            <section (click)="goToPhotobooth('vintage-photobooth')"
                class="flex-shrink-0 w-[300px] relative cursor-pointer group scroll-reveal photobooth-card-reveal stagger-1">
                <div class="aspect-[346/450] h-full w-full bg-center bg-cover media-primary relative transition-transform duration-500 group-hover:scale-[1.02]"
                    style="background-image: url('/assets/visidea/vintage-photobooth.JPG');">
                    <!-- Subtle Bottom Gradient Scrim -->
                    <div
                        class="absolute inset-x-0 bottom-0 h-44 bg-gradient-to-t from-black/70 via-black/25 to-transparent pointer-events-none">
                    </div>
                </div>
                <div class="absolute bottom-6 left-6 right-24 flex justify-between items-end pointer-events-none z-10">
                    <div class="text-white">
                        <h4 class="text-3xl font-semibold leading-tight">Vintage</h4>
                        <p class="text-3xl font-semibold leading-tight">Photobooth</p>
                    </div>
                </div>
                <!-- Pure Coded Circular Navy Button with SVG Diagonal Arrow -->
                <div
                    class="absolute bottom-2 right-2 w-[84px] h-[84px] bg-[#102B51] group-hover:bg-[#163861] rounded-full flex items-center justify-center transition-all duration-300 shadow-md group-hover:scale-105 z-10 cursor-pointer">
                    <svg class="w-7 h-7 text-white transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                        fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
                    </svg>
                </div>
            </section>

            <!-- Card 2: Hyppe Photobooth -->
            <section (click)="goToPhotobooth('hyppe-photobooth')"
                class="flex-shrink-0 w-[300px] relative cursor-pointer group scroll-reveal photobooth-card-reveal stagger-2">
                <div class="aspect-[346/450] h-full w-full bg-center bg-cover media-primary relative transition-transform duration-500 group-hover:scale-[1.02]"
                    style="background-image: url('/assets/visidea/hyppe-photobooth.JPG');">
                    <!-- Subtle Bottom Gradient Scrim -->
                    <div
                        class="absolute inset-x-0 bottom-0 h-44 bg-gradient-to-t from-black/70 via-black/25 to-transparent pointer-events-none">
                    </div>
                </div>
                <div class="absolute bottom-6 left-6 right-24 flex justify-between items-end pointer-events-none z-10">
                    <div class="text-white">
                        <h4 class="text-3xl font-semibold leading-tight">Hyppe</h4>
                        <p class="text-3xl font-semibold leading-tight">Photobooth</p>
                    </div>
                </div>
                <!-- Pure Coded Circular Navy Button with SVG Diagonal Arrow -->
                <div
                    class="absolute bottom-2 right-2 w-[84px] h-[84px] bg-[#102B51] group-hover:bg-[#163861] rounded-full flex items-center justify-center transition-all duration-300 shadow-md group-hover:scale-105 z-10 cursor-pointer">
                    <svg class="w-7 h-7 text-white transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                        fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
                    </svg>
                </div>
            </section>

            <!-- Card 3: Poppy Photobooth -->
            <section (click)="goToPhotobooth('poppy-photobooth')"
                class="flex-shrink-0 w-[300px] relative cursor-pointer group scroll-reveal photobooth-card-reveal stagger-3">
                <div class="aspect-[346/450] h-full w-full bg-cover bg-center media-primary relative transition-transform duration-500 group-hover:scale-[1.02]"
                    style="background-image: url('/assets/visidea/foto-Poppy.png');">
                    <!-- Subtle Bottom Gradient Scrim -->
                    <div
                        class="absolute inset-x-0 bottom-0 h-44 bg-gradient-to-t from-black/70 via-black/25 to-transparent pointer-events-none">
                    </div>
                </div>
                <div class="absolute bottom-6 left-6 right-24 flex justify-between items-end pointer-events-none z-10">
                    <div class="text-white">
                        <h4 class="text-3xl font-semibold leading-tight">Poppy</h4>
                        <p class="text-3xl font-semibold leading-tight">Photobooth</p>
                    </div>
                </div>
                <!-- Pure Coded Circular Navy Button with SVG Diagonal Arrow -->
                <div
                    class="absolute bottom-2 right-2 w-[84px] h-[84px] bg-[#102B51] group-hover:bg-[#163861] rounded-full flex items-center justify-center transition-all duration-300 shadow-md group-hover:scale-105 z-10 cursor-pointer">
                    <svg class="w-7 h-7 text-white transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                        fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
                    </svg>
                </div>
            </section>

            <!-- Card 4: 360 Rolly Photobooth -->
            <section (click)="goToPhotobooth('360-rolly')"
                class="flex-shrink-0 w-[300px] relative cursor-pointer group scroll-reveal photobooth-card-reveal stagger-4">
                <div class="aspect-[346/450] h-full w-full bg-cover bg-center media-primary relative transition-transform duration-500 group-hover:scale-[1.02]"
                    style="background-image: url('/assets/visidea/360rolly-photobooth.PNG');">
                    <!-- Subtle Bottom Gradient Scrim -->
                    <div
                        class="absolute inset-x-0 bottom-0 h-44 bg-gradient-to-t from-black/70 via-black/25 to-transparent pointer-events-none">
                    </div>
                </div>
                <div class="absolute bottom-6 left-6 right-24 flex justify-between items-end pointer-events-none z-10">
                    <div class="text-white">
                        <h4 class="text-3xl font-semibold leading-tight">360 Rolly</h4>
                        <p class="text-3xl font-semibold leading-tight">Photobooth</p>
                    </div>
                </div>
                <!-- Pure Coded Circular Navy Button with SVG Diagonal Arrow -->
                <div
                    class="absolute bottom-2 right-2 w-[84px] h-[84px] bg-[#102B51] group-hover:bg-[#163861] rounded-full flex items-center justify-center transition-all duration-300 shadow-md group-hover:scale-105 z-10 cursor-pointer">
                    <svg class="w-7 h-7 text-white transition-transform duration-300 group-hover:translate-x-1 group-hover:-translate-y-1"
                        fill="none" stroke="currentColor" stroke-width="2.5" viewBox="0 0 24 24" aria-hidden="true">
                        <path stroke-linecap="round" stroke-linejoin="round"
                            d="M4.5 19.5l15-15m0 0H8.25m11.25 0v11.25" />
                    </svg>
                </div>
            </section>
        </div>

        <!-- SVG Defs for smooth circular scooped corner -->
        <svg width="0" height="0" class="absolute pointer-events-none" aria-hidden="true">
            <defs>
                <clipPath id="clip-rounded" clipPathUnits="objectBoundingBox">
                    <path
                        d="M 0.0800,0 H 0.9200 A 0.0800 0.0615 0 0 1 1.0000,0.0615 V 0.7040 A 0.0667 0.0513 0 0 1 0.9056,0.7506 A 0.1733 0.1333 0 0 0 0.6758,0.9274 A 0.0667 0.0513 0 0 1 0.6152,1.0000 H 0.0800 A 0.0800 0.0615 0 0 1 0,0.9385 V 0.0615 A 0.0800 0.0615 0 0 1 0.0800,0 Z" />
                </clipPath>
            </defs>
        </svg>
    </div>
</section>

<!-- Digital Wedding Invitation Showcase - Clean Aesthetic 3D Curved Smartphone Gallery -->
<section class="py-15 md:py-15 px-4 sm:px-6 lg:px-8 bg-[#FBFBFC] relative border-t border-gray-100">

    <!-- Decorative Left & Right Side Mascots / Icons (Positioned inside the grey background) -->
    <div
        class="absolute left-3 sm:left-6 md:left-10 lg:left-14 bottom-4 sm:bottom-6 md:bottom-8 lg:bottom-10 pointer-events-none z-20 select-none scroll-reveal scroll-reveal-left">
        <img src="/assets/visidea/craftybyul_1.png" alt="Icon Solusi Visidea"
            class="w-32 sm:w-44 md:w-52 lg:w-64 xl:w-72 h-auto object-contain drop-shadow-md">
    </div>

    <div
        class="absolute right-3 sm:right-6 md:right-10 lg:right-14 bottom-4 sm:bottom-6 md:bottom-8 lg:bottom-10 pointer-events-none z-20 select-none scroll-reveal scroll-reveal-right">
        <img src="/assets/visidea/craftybyul_2.png" alt="Icon Tim Visidea"
            class="w-32 sm:w-44 md:w-52 lg:w-64 xl:w-72 h-auto object-contain drop-shadow-md">
    </div>

    <div class="max-w-7xl mx-auto relative z-10 pt-8 md:pt-14">

        <!-- Header & Action Button -->
        <div class="text-center max-w-3xl mx-auto mb-12 md:mb-16 space-y-4 scroll-reveal scroll-reveal-up">
            <h2 class="text-lg lg:text-4xl font-normal text-gray-900 tracking-tight">
                Pilihan Tema <span class="font-bold">Terbaik</span>
            </h2>
            <p class="text-sm md:text-lg text-gray-500 font-normal tracking-normal max-w-xl mx-auto leading-relaxed">
                Temukan beragam pilihan desain tema undangan
                pernikahan digital impianmu dengan tampilan ponsel
                kekinian yang cantik dan interaktif.
            </p>
        </div>

        <!-- 3D Curved Smartphone Carousel Stage (Automatic Scroll + Interactive Drag/Swipe) -->
        <div class="relative w-full py-2 select-none cursor-grab active:cursor-grabbing scroll-reveal scroll-reveal-up stagger-1"
            (mousedown)="onMouseDown($event)" (mousemove)="onMouseMove($event)" (mouseup)="onMouseUp()"
            (mouseleave)="onMouseLeave()" (touchstart)="onTouchStart($event)" (touchmove)="onTouchMove($event)"
            (touchend)="onTouchEnd()">

            <!-- 3D Perspective Stage Container -->
            <div
                class="carousel-stage relative h-[400px] sm:h-[440px] md:h-[480px] w-full flex items-center justify-center overflow-visible">

                <!-- Loop over Smartphone Cards -->
                <div *ngFor="let item of weddingProducts; let i = index" [ngStyle]="getCardStyle(i)"
                    (click)="onCardClick(i)" class="carousel-card absolute cursor-pointer group/phone">

                    <!-- CARD VARIANT 1: Wedding Invitation Mockup -->
                    <div *ngIf="item.hasPhoneFrame; else defaultPhoneChassis"
                        class="relative w-[190px] sm:w-[215px] md:w-[235px] h-[380px] sm:h-[430px] md:h-[470px] select-none transition-all duration-500 flex flex-col justify-end">

                        <div
                            class="relative w-full h-full rounded-[28px] overflow-hidden drop-shadow-[0_20px_35px_rgba(0,0,0,0.18)] group-hover/phone:drop-shadow-[0_25px_45px_rgba(32,35,103,0.3)] transition-all duration-500">
                            <!-- Primary Cover Image -->
                            <img [src]="item.image" [alt]="item.title"
                                class="absolute inset-0 w-full h-full object-contain pointer-events-none transition-all duration-700"
                                [ngClass]="item.hoverImage ? 'group-hover/phone:opacity-0 group-hover/phone:scale-105' : 'group-hover/phone:scale-105'">

                            <!-- Secondary Hover Image (when available) -->
                            <img *ngIf="item.hoverImage" [src]="item.hoverImage" [alt]="item.title + ' preview 2'"
                                class="absolute inset-0 w-full h-full object-contain pointer-events-none opacity-0 group-hover/phone:opacity-100 group-hover/phone:scale-105 transition-all duration-700">
                        </div>
                    </div>

                    <!-- CARD VARIANT 2: All Other Themes - Full Smartphone Chassis with Dynamic Island, Screen Bezel & Content -->
                    <ng-template #defaultPhoneChassis>
                        <div
                            class="relative w-[190px] sm:w-[215px] md:w-[235px] h-[380px] sm:h-[430px] md:h-[470px] rounded-[32px] md:rounded-[36px] p-[5px] md:p-[6px] bg-[#1A1D24] shadow-[0_20px_50px_-12px_rgba(0,0,0,0.22),0_0_0_1px_rgba(255,255,255,0.12)] ring-1 ring-black/10 select-none overflow-hidden transition-all duration-500">

                            <!-- Inner Screen Display -->
                            <div
                                class="relative w-full h-full rounded-[27px] md:rounded-[30px] overflow-hidden bg-slate-950 flex flex-col justify-between">

                                <!-- Dynamic Island (Minimal, realistic) -->
                                <div
                                    class="absolute top-2 left-1/2 -translate-x-1/2 w-16 md:w-18 h-3 md:h-3.5 bg-black/95 rounded-full z-40 flex items-center justify-end px-1.5 shadow-sm">
                                    <div class="w-1.5 h-1.5 rounded-full bg-[#111] border border-[#222]"></div>
                                </div>

                                <!-- Screen Glass Specular Glare Reflection -->
                                <div
                                    class="absolute inset-0 bg-gradient-to-tr from-transparent via-white/[0.08] to-transparent pointer-events-none z-30">
                                </div>

                                <!-- Full-bleed Wedding Photography Background -->
                                <img [src]="item.image" [alt]="item.title"
                                    class="absolute inset-0 w-full h-full object-cover object-center group-hover/phone:scale-105 transition-transform duration-700">

                                <!-- Cinematic Editorial Vignette Overlays -->
                                <div
                                    class="absolute inset-x-0 top-0 h-24 bg-gradient-to-b from-black/70 via-black/30 to-transparent z-10 pointer-events-none">
                                </div>
                                <div
                                    class="absolute inset-x-0 bottom-0 h-52 bg-gradient-to-t from-black/90 via-black/55 to-transparent z-10 pointer-events-none">
                                </div>

                                <!-- Screen UI Content (Clean, Luxury, Authentic) -->
                                <div class="relative z-20 h-full flex flex-col justify-between p-3 sm:p-4 pt-6 md:pt-7">
                                    <!-- Top Bar Header inside Phone -->
                                    <div class="flex items-center justify-between">
                                        <span
                                            class="text-[7px] sm:text-[8px] tracking-[0.2em] font-semibold text-white/80 uppercase">
                                            VISIDEA
                                        </span>
                                        <span
                                            class="text-[7px] sm:text-[8px] font-medium tracking-wider px-2 py-0.5 rounded-full bg-white/20 backdrop-blur-md text-white border border-white/30 shadow-sm">
                                            {{ item.badge }}
                                        </span>
                                    </div>

                                    <!-- Center & Lower Wedding Typography -->
                                    <div class="space-y-1 text-center pb-3 sm:pb-4">
                                        <p
                                            class="text-[7px] sm:text-[8px] uppercase tracking-[0.25em] text-amber-200/90 font-light">
                                            THE WEDDING OF
                                        </p>
                                        <h4
                                            class="text-lg sm:text-xl md:text-2xl font-serif text-white font-normal tracking-wide leading-tight drop-shadow-md my-0.5">
                                            {{ item.coupleName }}
                                        </h4>
                                        <p class="text-[9px] sm:text-[10px] text-white/75 font-light tracking-widest">
                                            {{ item.weddingDate }}
                                        </p>
                                    </div>

                                    <!-- Smartphone Bottom Home Indicator Bar -->
                                    <div
                                        class="absolute bottom-1.5 left-1/2 -translate-x-1/2 w-20 sm:w-24 h-0.5 bg-white/60 rounded-full z-30 pointer-events-none">
                                    </div>
                                </div>
                            </div>
                        </div>
                    </ng-template>

                </div>

            </div>

        </div>

    </div>

    <!-- Modal Pilih Agama (Visidea Editorial Dialog) -->
    <div *ngIf="isAgamaModalOpen"
        class="fixed inset-0 z-50 flex items-center justify-center p-4 sm:p-6 bg-[#0A0E1A]/65 backdrop-blur-sm modal-backdrop-animate"
        (click)="closeAgamaModal()">

        <!-- Modal Card Box -->
        <div class="relative w-full max-w-lg bg-white rounded-2xl p-6 sm:p-8 shadow-[0_25px_60px_-15px_rgba(16,43,81,0.25)] border border-slate-100 overflow-hidden modal-dialog-animate"
            (click)="$event.stopPropagation()">

            <!-- Top Brand Line Accent -->
            <div class="absolute top-0 inset-x-0 h-1.5 bg-[#102B51]"></div>

            <!-- Close Button -->
            <button (click)="closeAgamaModal()" aria-label="Tutup"
                class="absolute top-5 right-5 w-8 h-8 rounded-full bg-slate-100 hover:bg-slate-200 text-slate-500 hover:text-slate-800 flex items-center justify-center transition-colors">
                <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                    <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2" d="M6 18L18 6M6 6l12 12" />
                </svg>
            </button>

            <!-- Header -->
            <div class="mb-6 pr-8">
                <div class="flex items-center gap-2 mb-2">
                    <span class="w-2 h-2 rounded-full bg-[#102B51]"></span>
                    <span
                        class="text-[10px] sm:text-[11px] font-bold tracking-[0.15em] text-[#102B51] uppercase">VISIDEA
                        DIGITAL INVITATION</span>
                </div>
                <h3 class="text-xl sm:text-2xl font-bold text-[#102B51] tracking-tight">
                    Pilih Format Agama
                </h3>
                <p class="text-xs sm:text-sm text-slate-500 mt-1 leading-relaxed">
                    Pilih format agama untuk menampilkan tata cara dan kutipan doa yang sesuai pada demo undangan.
                </p>
            </div>

            <!-- Religion Selection Options (Clean 2-Column Grid) -->
            <div class="grid grid-cols-1 sm:grid-cols-2 gap-2.5 mb-6">
                <button *ngFor="let rel of religions" type="button" (click)="selectAgama(rel.id)"
                    [class]="'flex items-center justify-between p-3.5 rounded-xl border text-left transition-all duration-150 ' +
                             (selectedAgama === rel.id 
                                ? 'bg-[#F4F8FE] border-[#102B51] text-[#102B51] shadow-sm ring-1 ring-[#102B51]' 
                                : 'bg-white text-slate-700 border-slate-200 hover:border-slate-300 hover:bg-slate-50')">
                    <div class="flex items-center gap-3">
                        <!-- Custom Radio Indicator -->
                        <div [class]="'w-4 h-4 rounded-full border flex items-center justify-center shrink-0 ' + 
                                     (selectedAgama === rel.id ? 'border-[#102B51]' : 'border-slate-300')">
                            <div *ngIf="selectedAgama === rel.id" class="w-2 h-2 rounded-full bg-[#102B51]"></div>
                        </div>
                        <div>
                            <div class="text-xs sm:text-sm font-semibold tracking-tight">{{ rel.name }}</div>
                            <div class="text-[10px] sm:text-[11px] text-slate-400 mt-0.5">{{ rel.ceremony }}</div>
                        </div>
                    </div>

                    <!-- Subtle Check Indicator for Selected Item -->
                    <svg *ngIf="selectedAgama === rel.id" class="w-4 h-4 text-[#102B51] shrink-0" fill="none"
                        stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M5 13l4 4L19 7" />
                    </svg>
                </button>
            </div>

            <!-- Current Selected Theme Info Preview -->
            <div *ngIf="selectedProductForDemo"
                class="flex items-center justify-between py-2.5 px-3.5 bg-slate-50 rounded-xl border border-slate-100 text-xs mb-5">
                <span class="text-slate-500">Tema Desain:</span>
                <span class="font-semibold text-[#102B51]">{{ selectedProductForDemo.title }}</span>
            </div>

            <!-- Action Buttons Footer -->
            <div class="flex items-center gap-3">
                <button type="button" (click)="closeAgamaModal()"
                    class="py-3 px-5 rounded-xl border border-slate-200 hover:bg-slate-50 text-slate-600 text-xs sm:text-sm font-medium transition-colors cursor-pointer">
                    Batal
                </button>
                <button type="button" (click)="confirmAgamaAndOpenDemo()" [disabled]="isSubmittingAgama"
                    class="flex-1 py-3 px-5 rounded-xl bg-[#102B51] hover:bg-[#1A3D6E] text-white text-xs sm:text-sm font-semibold tracking-wide flex items-center justify-center gap-2 shadow-sm hover:shadow transition-all active:scale-[0.99] disabled:opacity-75 cursor-pointer">
                    <svg *ngIf="!isSubmittingAgama" class="w-4 h-4" fill="none" stroke="currentColor"
                        viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M15 12a3 3 0 11-6 0 3 3 0 016 0z" />
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M2.458 12C3.732 7.943 7.523 5 12 5c4.478 0 8.268 2.943 9.542 7-1.274 4.057-5.064 7-9.542 7-4.477 0-8.268-2.943-9.542-7z" />
                    </svg>
                    <span *ngIf="!isSubmittingAgama">Lihat Demo Undangan</span>
                    <span *ngIf="isSubmittingAgama" class="flex items-center gap-2">
                        <svg class="animate-spin h-4 w-4 text-white" fill="none" viewBox="0 0 24 24">
                            <circle class="opacity-25" cx="12" cy="12" r="10" stroke="currentColor" stroke-width="4">
                            </circle>
                            <path class="opacity-75" fill="currentColor" d="M4 12a8 8 0 018-8v8H4z"></path>
                        </svg>
                        <span>Membuka...</span>
                    </span>
                </button>
            </div>

        </div>
    </div>
</section>

<!-- Digital Guest Book Section (Buku Tamu Digital) - 100% Exact Asymmetric Rounded Corner Layout matching Reference -->
<section id="guest-book" class="py-16 md:py-24 px-6 sm:px-10 lg:px-16 bg-white relative overflow-hidden">
    <div class="max-w-7xl mx-auto relative z-10">

        <!-- Top Header Section: Clean Aligned Kicker & Proportionate Main Heading -->
        <div class="mb-10 md:mb-12 max-w-2xl scroll-reveal scroll-reveal-up">
            <h2 class="text-lg lg:text-4xl font-normal text-gray-900 leading-snug tracking-tight">
                Sistem buku tamu digital & QR check-in, <span class="font-bold">Visidea menghadirkan pencatatan
                    kehadiran cepat dan aman.</span>
            </h2>
        </div>

        <!-- 4 Cards Row: Lite Details, Lite Photo, Premium Photo, and Premium Details -->
        <div class="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-6 items-stretch">

            <!-- Card 1: Lite Guest Book Product Details Card with Top-Right Asymmetric Curve -->
            <div class="relative min-h-[380px] md:min-h-[420px] bg-[#0A1128] text-white p-6 sm:p-7 flex flex-col justify-between shadow-xl transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 scroll-reveal scroll-reveal-up stagger-1"
                style="border-radius: 28px 100px 28px 28px;">
                <!-- Content (Vertically Centered) -->
                <div class="my-auto py-2">
                    <h3 class="text-xl sm:text-2xl font-bold text-white tracking-tight">
                        Lite Guest Book
                    </h3>
                    <div class="mt-2 mb-4">
                        <span class="text-[11px] text-gray-400 font-normal block">Mulai dari</span>
                        <div class="text-2xl sm:text-3xl font-extrabold text-[#93C5FD]">
                            Rp750.000
                        </div>
                    </div>

                    <!-- Features Checklist -->
                    <ul class="space-y-2.5 text-xs sm:text-[13px] text-gray-300">
                        <li class="flex items-start gap-2">
                            <span class="text-[#93C5FD] font-bold text-sm shrink-0">✓</span>
                            <span>QR Code check-in cepat via mobile</span>
                        </li>
                        <li class="flex items-start gap-2">
                            <span class="text-[#93C5FD] font-bold text-sm shrink-0">✓</span>
                            <span>Real-time dashboard kehadiran tamu</span>
                        </li>
                        <li class="flex items-start gap-2">
                            <span class="text-[#93C5FD] font-bold text-sm shrink-0">✓</span>
                            <span>Export data tamu (Excel / CSV)</span>
                        </li>
                        <li class="flex items-start gap-2">
                            <span class="text-[#93C5FD] font-bold text-sm shrink-0">✓</span>
                            <span>1 dedicated crew technical support</span>
                        </li>
                    </ul>
                </div>

                <!-- Action Button -->
                <button (click)="goToGuestBook('lite')"
                    class="mt-4 w-full bg-[#102B51] hover:bg-[#1A3D6E] active:bg-[#0D2240] text-white font-semibold py-2.5 px-4 rounded-xl text-xs sm:text-sm transition-all duration-200 shadow-md flex items-center justify-center gap-1.5 cursor-pointer">
                    <span>Pesan Sekarang</span>
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                </button>
            </div>

            <!-- Card 2: Lite Guest Book Photo Card with Top-Left Asymmetric Curve (Non-clickable) -->
            <div class="group/card relative min-h-[380px] md:min-h-[420px] flex flex-col justify-between p-6 sm:p-7 shadow-xl transition-all duration-500 overflow-hidden select-none pointer-events-none scroll-reveal scroll-reveal-up stagger-2"
                style="border-radius: 100px 28px 28px 28px;">
                <!-- Full-bleed Bright Image -->
                <img src="/assets/visidea/guestbook1.png" alt="Digital Guest Book"
                    class="absolute inset-0 w-full h-full object-cover object-center group-hover/card:scale-105 transition-transform duration-700">
                <!-- Top Frosted Glass Pill (Top Right) -->
                <div class="relative z-10 flex justify-end">
                    <span
                        class="bg-black/40 backdrop-blur-md border border-white/30 text-white text-[10px] sm:text-xs font-bold uppercase tracking-wider px-3.5 py-1.5 rounded-full shadow-lg inline-block">
                        LITE GUEST BOOK
                    </span>
                </div>
            </div>

            <!-- Card 3: Premium Guest Book Photo Card with Top-Right Asymmetric Curve (Non-clickable) -->
            <div class="relative min-h-[380px] md:min-h-[420px] scroll-reveal scroll-reveal-up stagger-3">
                <div class="group/card relative w-full h-full min-h-[380px] md:min-h-[420px] flex flex-col justify-between p-6 sm:p-7 text-white shadow-xl transition-all duration-500 overflow-hidden select-none pointer-events-none"
                    style="border-radius: 28px 100px 28px 28px;">
                    <!-- Full-bleed Bright Image -->
                    <img src="/assets/visidea/guestbook2.png" alt="Premium Guest Book"
                        class="absolute inset-0 w-full h-full object-cover object-center group-hover/card:scale-105 transition-transform duration-700">
                    <!-- Bottom Frosted Glass Pill (Bottom Left) -->
                    <div class="relative z-10 self-start">
                        <span
                            class="bg-black/40 backdrop-blur-md border border-white/30 text-white text-[10px] sm:text-xs font-bold uppercase tracking-wider px-3.5 py-1.5 rounded-full shadow-lg inline-block">
                            PREMIUM GUEST BOOK
                        </span>
                    </div>
                </div>
            </div>

            <!-- Card 4: Premium Guest Book Product Details Card with Top-Left Asymmetric Curve -->
            <div class="relative min-h-[380px] md:min-h-[420px] bg-[#0A1128] text-white p-6 sm:p-7 flex flex-col justify-between shadow-xl transition-all duration-300 hover:shadow-2xl hover:-translate-y-1 scroll-reveal scroll-reveal-up stagger-4"
                style="border-radius: 100px 28px 28px 28px;">
                <!-- Content (Vertically Centered) -->
                <div class="my-auto py-2">
                    <h3 class="text-xl sm:text-2xl font-bold text-white tracking-tight">
                        Premium Guest Book
                    </h3>
                    <div class="mt-2 mb-4">
                        <span class="text-[11px] text-gray-400 font-normal block">Mulai dari</span>
                        <div class="text-2xl sm:text-3xl font-extrabold text-[#34D399]">
                            Rp1.500.000
                        </div>
                    </div>

                    <!-- Features Checklist -->
                    <ul class="space-y-2.5 text-xs sm:text-[13px] text-gray-300">
                        <li class="flex items-start gap-2">
                            <span class="text-[#34D399] font-bold text-sm shrink-0">✓</span>
                            <span>Termasuk semua fitur Paket Lite</span>
                        </li>
                        <li class="flex items-start gap-2">
                            <span class="text-[#34D399] font-bold text-sm shrink-0">✓</span>
                            <span>Dedicated iPad & Stand di venue</span>
                        </li>
                        <li class="flex items-start gap-2">
                            <span class="text-[#34D399] font-bold text-sm shrink-0">✓</span>
                            <span>Live greeting display & scan souvenir</span>
                        </li>
                        <li class="flex items-start gap-2">
                            <span class="text-[#34D399] font-bold text-sm shrink-0">✓</span>
                            <span>2 crew & IT support onsite acara</span>
                        </li>
                    </ul>
                </div>

                <!-- Action Button -->
                <button (click)="goToGuestBook('premium')"
                    class="mt-4 w-full bg-gradient-to-r from-[#059669] to-[#047857] hover:from-[#047857] hover:to-[#065F46] text-white font-semibold py-2.5 px-4 rounded-xl text-xs sm:text-sm transition-all duration-200 shadow-md flex items-center justify-center gap-1.5 cursor-pointer">
                    <span>Pesan Sekarang</span>
                    <svg class="w-4 h-4" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                        <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2"
                            d="M14 5l7 7m0 0l-7 7m7-7H3" />
                    </svg>
                </button>
            </div>

        </div>

    </div>
</section>

<!-- ========================================================= -->
<!-- OUR PARTNERS INFINITE STREAM SECTION (CLEAN -->
<!-- ========================================================= -->
<section id="our-partners" class="py-12 md:py-20 bg-white relative overflow-hidden border-t border-gray-100">
    <div class="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 text-center scroll-reveal scroll-reveal-up">

        <!-- Section Title -->
        <h2 class="text-2xl sm:text-3xl lg:text-4xl font-normal text-gray-900 leading-snug tracking-tight">
            <span class="font-bold">Our Partners</span>
        </h2>

        <!-- Section Description -->
        <p class="mt-3 text-xs sm:text-sm md:text-base text-gray-500 max-w-2xl mx-auto font-normal leading-relaxed">
            Mendukung kesuksesan ratusan event prestisius, wedding megah, festival, institusi pendidikan, hingga
            instansi pemerintah dengan ekosistem digital Visidea Studio.
        </p>

    </div>

    <!-- Infinite Stream -->
    <div class="relative w-full overflow-hidden marquee-edge-mask mt-8 md:mt-14 py-4 scroll-reveal scroll-reveal-up stagger-2">

        <!-- Row 1: Flowing Left -->
        <div class="flex overflow-hidden py-3">
            <div class="partner-marquee-left flex items-center gap-12 sm:gap-16 md:gap-24">
                <div *ngFor="let partner of partnersRow1"
                    class="flex-shrink-0 flex items-center justify-center transition-all duration-300 hover:scale-110">
                    <img [src]="partner.asset?.url" [alt]="partner.displayName || 'Partner Logo'"
                        class="h-10 sm:h-12 md:h-14 max-w-[140px] sm:max-w-[180px] w-auto object-contain select-none opacity-85 hover:opacity-100 transition-opacity">
                </div>
            </div>
        </div>

        <!-- Row 2: Flowing Right (Reverse) -->
        <div class="flex overflow-hidden py-3 mt-3 sm:mt-5">
            <div class="partner-marquee-right flex items-center gap-12 sm:gap-16 md:gap-24">
                <div *ngFor="let partner of partnersRow2"
                    class="flex-shrink-0 flex items-center justify-center transition-all duration-300 hover:scale-110">
                    <img [src]="partner.asset?.url" [alt]="partner.displayName || 'Partner Logo'"
                        class="h-10 sm:h-12 md:h-14 max-w-[140px] sm:max-w-[180px] w-auto object-contain select-none opacity-85 hover:opacity-100 transition-opacity">
                </div>
            </div>
        </div>

    </div>
</section>


<!-- ========================================================= -->
<!-- SHOPEE-STYLE WELCOME VOUCHER POPUP (POPUP SAAT BUKA HOME) -->
<!-- ========================================================= -->
<div *ngIf="isVoucherPopupOpen && voucherBannerUrl"
    class="fixed inset-0 z-[999] flex items-center justify-center p-4 sm:p-6 overflow-y-auto modal-backdrop-animate">
    <!-- Frosted Backdrop (Click to close) -->
    <div (click)="closeVoucherPopup($event)"
        class="fixed inset-0 bg-black/70 backdrop-blur-sm transition-opacity cursor-pointer"></div>

    <!-- Popup Container Box - ONLY THE IMAGE & CLOSE BUTTON -->
    <div class="relative max-w-sm sm:max-w-md w-full z-10 voucher-popup-animate select-none flex flex-col items-center">
        <!-- Floating Close Button (Top-Right of Image) -->
        <button (click)="closeVoucherPopup($event)" aria-label="Tutup Pop-up Voucher"
            class="absolute -top-3.5 -right-3.5 sm:-top-4 sm:-right-4 w-9 h-9 sm:w-10 sm:h-10 rounded-full bg-white text-gray-800 shadow-2xl flex items-center justify-center transition-all duration-200 hover:scale-110 hover:rotate-90 z-30 cursor-pointer border border-gray-200">
            <svg class="w-5 h-5" fill="none" stroke="currentColor" viewBox="0 0 24 24">
                <path stroke-linecap="round" stroke-linejoin="round" stroke-width="2.5" d="M6 18L18 6M6 6l12 12"></path>
            </svg>
        </button>

        <!-- Pure Voucher Image (Click to go to /voucher) -->
        <img (click)="goToVoucherPage()" [src]="voucherBannerUrl" [alt]="promoBanner?.title || 'Voucher Promo Visidea'"
            class="w-full h-auto object-contain rounded-2xl drop-shadow-[0_20px_40px_rgba(0,0,0,0.6)] cursor-pointer transition-transform duration-200 hover:scale-[1.02] block">
    </div>
</div>